export default {
  isLoggedIn: false,
  apiKey: null,
  config: null,
  tenant: null,
}
